import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import "./App.css";
import ROUTE_PATHS from "./utils/routePaths";
import { CssBaseline, ThemeProvider } from "@mui/material";
import theme from "./utils/theme";
import WelcomeScreen from "./screens/Welcome Screen/WelcomeScreen";
import SigninScreen from "./screens/Signin Screen/SigninScreen";
import InitialLoadScreen from "./screens/Initial Load Screen/InitialLoadScreen";
import WorkspaceDetailScreen from "screens/Workspace Detail Screen/WorkspaceDetailScreen";
import MeetingRoomListScreen from "screens/Meeting Room List Screen/MeetingRoomListScreen";
import { TabBarProvider } from "services/TabBarProvider";
import HomeScreen from "screens/Home Screen/HomeScreen";
import CreditPlanDetailScreen from "screens/Membership Screen/Credit Plan Detail Screen/CreditPlanDetailScreen";
import OneDayPassDetailScreen from "screens/Membership Screen/One Day Pass Detail Screen/OneDayPassDetailScreen";
import MembershipPlanDetailScreen from "screens/Membership Screen/Membership Plan Detail Screen/MembershipPlanDetailScreen";
import URMembershipPlanDetailScreen from "screens/Membership Screen/UR Membership Plan Detail Screen/URMembershipPlanDetailScreen";
import MembershipPaymentDetailScreen from "screens/Membership Screen/Membership Payment Detail Screen/MembershipPaymentDetailScreen";
import CalendarPaymentScreen from "screens/Calendar Payment Screen/CalendarPaymentScreen";
import DFWorkspaceDetailScreen from "screens/Calendar Detail Screens/DF Workspace Detail Screen/DFWorkspaceDetailScreen";
import EventDetailScreen from "screens/Calendar Detail Screens/Event Detail Screen/EventDetailScreen";
import MBStudioDetailScreen from "screens/Calendar Detail Screens/MB Studio Detail Screen/MBStudioDetailScreen";
import ProfileSetupScreen from "screens/Profile Setup Screen/ProfileSetupScreen";
import CommunicateSpaceDetailScreen from "screens/Calendar Detail Screens/Communicate Space Detail Screen/CommunicateSpaceDetailScreen";
import FAQDetailScreen from "screens/FAQ Detail Screen/FAQDetailScreen";
import WebLinkDetailScreen from "screens/Web Link Detail Screen/WebLinkDetailScreen";
import AllSetScreen from "screens/Membership Screen/All Set Screen/AllSetScreen";
import RetreatDetailScreen from "screens/Retreat Detail Screen/RetreatDetailScreen";
import ReservationCancelSuccessScreen from "screens/Reservation Cancel Success Screen/ReservationCancelSuccessScreen";
import PaymentHistoryScreen from "screens/Payment History Screen/PaymentHistoryScreen";
import PaymentHistoryDetailScreen from "screens/Payment History Screen/Payment History Detail Screen/PaymentHistoryDetailScreen";
import InnovativeSpaceDetailScreen from "screens/Calendar Detail Screens/Innovative Space Detail Screen/InnovativeSpaceDetailScreen";
import CreativeSpaceDetailScreen from "screens/Calendar Detail Screens/Creative Space Detail Screen/CreativeSpaceDetailScreen";
import KeysDetailScreen from "screens/Keys Detail Screen/KeysDetailScreen";
import ScoreCardInitialScreen from "screens/Score Card Screens/Score Card Initial Screen/ScoreCardInitialScreen";
import ScoreCardMattersScreen from "screens/Score Card Screens/Score Card Matters Screen/ScoreCardMattersScreen";
import ScoreCardQuestionScreen from "screens/Score Card Screens/Score Card Question Screen/ScoreCardQuestionScreen";
import ScoreCardReadinessScreen from "screens/Score Card Screens/Score Card Readiness Screen/ScoreCardReadinessScreen";
import ScoreCardResultScreen from "screens/Score Card Screens/Score Card Result Screen/ScoreCardResultScreen";
import ScratchCardScreen from "screens/Score Card Screens/Scratch Card Screen/ScratchCardScreen";
import usePageTracking from "services/usePageTracking"; // ← NEW
import ProfileSetupSecondScreen from "screens/Profile Setup Screen/ProfileSetupSecondScreen";
import ProfileSetupThirdScreen from "screens/Profile Setup Screen/ProfileSetupThirdScreen";
import ProfileSetupFourthScreen from "screens/Profile Setup Screen/ProfileSteupFourthScreen";
import PassDetailScreen from "screens/Calendar Detail Screens/Pass Detail Screen/PassDetailScreen";
import PassesScreen from "screens/Passes Screen/PassesScreen";
import TheFoundryDetailScreen from "screens/Calendar Detail Screens/The Foundry Detail Screen/TheFoundryDetailScreen";
import { LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import ScalingWorkshopDetailScreen from "screens/Calendar Detail Screens/Scaling Workshop Detail Screen/ScalingWorkshopDetailScreen";
import SettingsScreen from "screens/Settings Screen/SettingsScreen";
import CalendarPassSuccessScreen from "screens/Calendar Pass Screen/Calendar Pass Success Screen/CalendarPassSuccessScreen";
import CalendarPassQuestionScreen from "screens/Calendar Pass Screen/Calendar Pass Question Screen/CalendarPassQuestionScreen";
import CalendarPassWelcomeScreen from "screens/Calendar Pass Screen/Calendar Pass Welcome Screen/CalendarPassWelcomeScreen";
import CalendarPassIntroductionScreen from "screens/Calendar Pass Screen/Calendar Pass Introduction Screen/CalendarPassIntroductionScreen";
import CalendarPassThankYouScreen from "screens/Calendar Pass Screen/Calendar Pass Thank You Screen/CalendarPassThankYouScreen";
import ExperiencePassesScreen from "screens/Experience Passes Screen/ExperiencePassesScreen";
import CalendarPassLastStageThankYouScreen from "screens/Calendar Pass Screen/Calendar Pass Last Stage Thank You Screen/CalendarPassLastStageThankYouScreen";
import DeepLinkLoginScreen from "screens/Deeplink Login Screen/DeeplinkLoginScreen";
import ExperiencePassesPaymentScreen from "screens/Experience Passes Payment Screen/ExperiencePassesPaymentScreen";

// ← NEW: inner component so usePageTracking can access Router context
const AppRoutes = () => {
  usePageTracking();

  return (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <Routes>
        <Route path={ROUTE_PATHS.HOME} element={<WelcomeScreen />} />
        <Route path={ROUTE_PATHS.WSM_SIGNIN} element={<SigninScreen />} />
        <Route
          path={ROUTE_PATHS.WSM_INITIAL_LOAD}
          element={<InitialLoadScreen />}
        />
        <Route
          path={ROUTE_PATHS.WSM_PROFILE_SETUP}
          element={<ProfileSetupScreen />}
        />
        <Route
          path={ROUTE_PATHS.WSM_PROFILE_SETUP_DETAIL}
          element={<ProfileSetupSecondScreen />}
        />
        <Route
          path={ROUTE_PATHS.WSM_PROFILE_SETUP_FOUNDER}
          element={<ProfileSetupThirdScreen />}
        />
        <Route
          path={ROUTE_PATHS.WSM_PROFILE_SETUP_NOT_FOUNDER}
          element={<ProfileSetupFourthScreen />}
        />
        <Route path={ROUTE_PATHS.WSM_FAQ} element={<FAQDetailScreen />} />
        <Route path={ROUTE_PATHS.WSM_KEYS} element={<KeysDetailScreen />} />
        <Route path={ROUTE_PATHS.WSM_HOME} element={<HomeScreen />} />
        <Route
          path={ROUTE_PATHS.WSM_WORKSPACE_DETAIL}
          element={<WorkspaceDetailScreen />}
        />
        <Route
          path={ROUTE_PATHS.WSM_EXPERIENCE_PASSES}
          element={<ExperiencePassesScreen />}
        />
        <Route
          path={ROUTE_PATHS.WSM_RETREAT_DETAIL}
          element={<RetreatDetailScreen />}
        />
        <Route
          path={ROUTE_PATHS.WSM_MEETING_ROOM_LIST}
          element={<MeetingRoomListScreen />}
        />
        <Route
          path={ROUTE_PATHS.WSM_CALENDAR_PAYMENT}
          element={<CalendarPaymentScreen />}
        />
        <Route
          path={ROUTE_PATHS.WSM_CALENDAR_DF_WORKSPACE_DETAIL}
          element={<DFWorkspaceDetailScreen />}
        />
        <Route
          path={ROUTE_PATHS.WSM_CALENDAR_INNOVATIVE_SPACE}
          element={<InnovativeSpaceDetailScreen />}
        />
        <Route
          path={ROUTE_PATHS.WSM_CALENDAR_CREATIVE_SPACE}
          element={<CreativeSpaceDetailScreen />}
        />
        <Route
          path={ROUTE_PATHS.WSM_CALENDAR_EVENT_DETAIL}
          element={<EventDetailScreen />}
        />
        <Route
          path={ROUTE_PATHS.WSM_CALENDAR_MB_STUDIO_DETAIL}
          element={<MBStudioDetailScreen />}
        />
        <Route
          path={ROUTE_PATHS.WSM_CALENDAR_COMMUNICATE_SPACE_DETAIL}
          element={<CommunicateSpaceDetailScreen />}
        />
        <Route
          path={ROUTE_PATHS.WSM_CALENDAR_THE_FOUNDRY_DETAIL}
          element={<TheFoundryDetailScreen />}
        />
        <Route
          path={ROUTE_PATHS.WSM_CALENDAR_SCALING_WORKSHOPS_DETAIL}
          element={<ScalingWorkshopDetailScreen />}
        />
        <Route
          path={ROUTE_PATHS.WSM_MEMBERSHIP_PLAN_DETAIL}
          element={<MembershipPlanDetailScreen />}
        />
        <Route
          path={ROUTE_PATHS.WSM_UR_MEMBERSHIP_PLAN_DETAIL}
          element={<URMembershipPlanDetailScreen />}
        />
        <Route
          path={ROUTE_PATHS.WSM_MEMBERSHIP_PAYMENT_DETAIL}
          element={<MembershipPaymentDetailScreen />}
        />
        <Route
          path={ROUTE_PATHS.WSM_MEMBERSHIP_CREDIT_PLAN_DETAIL}
          element={<CreditPlanDetailScreen />}
        />
        <Route
          path={ROUTE_PATHS.WSM_MEMBERSHIP_ONE_DAY_PASS_DETAIL}
          element={<OneDayPassDetailScreen />}
        />
        <Route path={ROUTE_PATHS.WSM_ALL_SET} element={<AllSetScreen />} />
        <Route
          path={ROUTE_PATHS.WSM_CALENDAR_PASS_WELCOME_SCREEN}
          element={<CalendarPassWelcomeScreen />}
        />
        <Route
          path={ROUTE_PATHS.WSM_CALENDAR_PASS_INTRODUCTION_SCREEN}
          element={<CalendarPassIntroductionScreen />}
        />
        <Route
          path={ROUTE_PATHS.WSM_CALENDAR_PASS_SUCCESS_SCREEN}
          element={<CalendarPassSuccessScreen />}
        />
        <Route
          path={ROUTE_PATHS.WSM_CALENDAR_PASS_THANK_YOU_SCREEN}
          element={<CalendarPassThankYouScreen />}
        />
        <Route
          path={ROUTE_PATHS.WSM_CALENDAR_PASS_LAST_STAGE_THANK_YOU_SCREEN}
          element={<CalendarPassLastStageThankYouScreen />}
        />
        <Route
          path={ROUTE_PATHS.WSM_CALENDAR_PASS_QUESTION_SCREEN}
          element={<CalendarPassQuestionScreen />}
        />
        <Route
          path={ROUTE_PATHS.WSM_WEB_LINK_DETAIL}
          element={<WebLinkDetailScreen />}
        />
        <Route
          path={ROUTE_PATHS.WSM_RESERVATION_CANCEL}
          element={<ReservationCancelSuccessScreen />}
        />
        <Route
          path={ROUTE_PATHS.WSM_PAYMENT_HISTORY}
          element={<PaymentHistoryScreen />}
        />
        <Route
          path={ROUTE_PATHS.WSM_PAYMENT_HISTORY_DETAIL}
          element={<PaymentHistoryDetailScreen />}
        />
        <Route
          path={ROUTE_PATHS.WSM_SCORE_CARD_INITIAL_SCREEN}
          element={<ScoreCardInitialScreen />}
        />
        <Route
          path={ROUTE_PATHS.WSM_SCORE_CARD_MATTERS_SCREEN}
          element={<ScoreCardMattersScreen />}
        />
        <Route
          path={ROUTE_PATHS.WSM_SCORE_CARD_QUESTION_SCREEN}
          element={<ScoreCardQuestionScreen />}
        />
        <Route
          path={ROUTE_PATHS.WSM_SCORE_CARD_READINESS_SCREEN}
          element={<ScoreCardReadinessScreen />}
        />
        <Route
          path={ROUTE_PATHS.WSM_SCORE_CARD_RESULT_SCREEN}
          element={<ScoreCardResultScreen />}
        />
        <Route
          path={ROUTE_PATHS.WSM_SCRATCH_CARD_SCREEN}
          element={<ScratchCardScreen />}
        />
        <Route
          path={ROUTE_PATHS.WSM_MEMBERSHIP_PASSES}
          element={<PassesScreen />}
        />
        <Route
          path={ROUTE_PATHS.WSM_MEMBERSHIP_PASS_DETAIL}
          element={<PassDetailScreen />}
        />
        <Route
          path={ROUTE_PATHS.WSM_SETTINGS_SCREEN}
          element={<SettingsScreen />}
        />
        <Route
          path={ROUTE_PATHS.WSM_SLOTS_LOGIN_SCREEN}
          element={<DeepLinkLoginScreen />}
        />
        <Route
          path={ROUTE_PATHS.WSM_SLOTS_PAYMENT_SCREEN}
          element={<ExperiencePassesPaymentScreen />}
        />
      </Routes>
    </LocalizationProvider>
  );
};

const App = () => {
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <TabBarProvider>
        <Router>
          <AppRoutes /> {/* ← replaces <Routes>...</Routes> */}
        </Router>
      </TabBarProvider>
    </ThemeProvider>
  );
};

export default App;
